// Temporary /search-demo only. Reuse the real search's AND matching and ranking.
import { matchesItem, queryWords, runQuery } from './search-core.js';

export const DEMO_TERMS = [
    'green', 'red', 'blue', 'black', 'white',
    'sheer', 'flare', 'pleated', 'asymmetric', 'structured',
    'skirt', 'dress', 'trouser', 'jacket', 'coat',
    'bag', 'shoe', 'boot', 'metallic', 'layered',
];

export function demoSearch(data, query = '', selected = []) {
    const words = [...new Set(queryWords([query, ...selected].join(' ').toLowerCase()))];
    const results = words.length ? runQuery(data, words.join(' ')) : data;
    // Count the intersection with the current results, including typed words
    // and ALL selected terms. Selected terms therefore show the current total.
    const counts = new Map(DEMO_TERMS.map(term => [term,
        results.filter(item => matchesItem(item, queryWords(term))).length]));
    return { results, counts };
}
